module.exports = __webpack_public_path__ + "static/media/1201.486cb337.jpg";